import { Link2, Layout, Download } from 'lucide-react';
import { ScrollReveal } from '@/components/common/ScrollReveal';
import { AppMockupFrame, MockPhotoGrid, MockFilterBar } from './mockups';

const WEB_PERKS = [
  {
    icon: Link2,
    text: 'URLを送るだけでかんたん共有',
  },
  {
    icon: Layout,
    text: 'アルバムで写真をまとめて管理',
  },
  {
    icon: Download,
    text: '高画質のまま一括ダウンロード',
  },
] as const;

/**
 * WebAccessSection
 * Webアプリの補助的な紹介セクション
 * 左テキスト + 右Webモックアップ
 */
export function WebAccessSection() {
  return (
    <section className="bg-muted/30 px-6 md:px-16 lg:px-24 py-24 md:py-32">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-[2fr_3fr] gap-16 items-center">
          {/* Left: Text */}
          <div>
            <ScrollReveal direction="up">
              <div className="text-[13px] font-semibold text-accent uppercase tracking-wider mb-4">
                Web App
              </div>
            </ScrollReveal>
            <ScrollReveal direction="up" delay={0.1}>
              <h2 className="text-3xl md:text-4xl font-semibold tracking-tight mb-4 leading-snug">
                スマホからも、
                <br />
                ブラウザからも
              </h2>
            </ScrollReveal>
            <ScrollReveal direction="up" delay={0.2}>
              <p className="text-base text-muted-foreground leading-relaxed mb-8">
                デスクトップアプリからクラウドに同期した写真は、Webブラウザからいつでも閲覧・共有できます。
              </p>
            </ScrollReveal>
            <ScrollReveal direction="up" delay={0.3}>
              <ul className="space-y-2">
                {WEB_PERKS.map((perk, index) => {
                  const Icon = perk.icon;
                  return (
                    <li key={index} className="flex items-center gap-3 py-2">
                      <Icon
                        className="w-[18px] h-[18px] text-accent flex-shrink-0"
                        strokeWidth={2}
                      />
                      <span className="text-sm text-muted-foreground">{perk.text}</span>
                    </li>
                  );
                })}
              </ul>
            </ScrollReveal>
          </div>

          {/* Right: Web Mockup */}
          <ScrollReveal direction="up" delay={0.4}>
            <AppMockupFrame variant="light" title="omokage.app">
              <MockFilterBar activeFilter="All" />
              <MockPhotoGrid columns={5} cellCount={10} variant="light" className="bg-background" />
            </AppMockupFrame>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
